import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IProps } from './models';
import { BlockHolder as Component } from './block-holder';

export const BlockHolder = createWidget<unknown, IProps>()(Component);
